export default __webpack_public_path__ + "static/media/oPai.19c39fe5.jpeg";